import * as commonScripts from '../common'

const cmpCookieNotice = {
  component: null,
  cookies: commonScripts.util.cookies,
  path: window.location.pathname.substr(0, window.location.pathname.lastIndexOf('/')),

  init: function (element) {
    const _ = this
    _.component = element
    const userType = element.attributes['data-region'].value + '-' + element.attributes['data-investortype'].value + '|'
    let termsCookie = _.cookies.get('termsCookie')
    if (termsCookie == null) {
      termsCookie = ''
    }

    if (termsCookie.indexOf(userType) > -1) {
      _.component.classList.add('d-none')
    } else {
      // const pathArr = _.path.split('/')
      // if (pathArr.length > 3) {
      //   _.path = '/' + pathArr[1] + '/' + pathArr[2]
      // }

      termsCookie += userType

      _.component.addEventListener('click', (e) => {
        _.cookies.set('termsCookie', termsCookie, '/') //_.path)
      })

      const closeBtn = element.querySelector('.cmp-cookie-notice__close')
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault()
        _.component.classList.add('d-none')
      })
    }
  }
}

export default cmpCookieNotice
